import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Row } from "components/Containers";
import { Tag } from "components/Tags";

/**
 * ApplicantAppliedRank
 *
 * @param {Object} scores
 */
const ApplicantAppliedRank = ({ scores, ...props }) => (
  <div data-vector-score={scores.vectorScore} {...props}>
    <Row gap="0.4rem" noWrap>
      <FormattedMessage
        id="Missions.Applicants.ApplicantAppliedRank.Value"
        values={{
          value: <Tag>{scores?.vectorRank ? scores.vectorRank : `-`}</Tag>,
        }}
      />
    </Row>
  </div>
);

ApplicantAppliedRank.propTypes = {
  scores: PropTypes.object,
};

export default ApplicantAppliedRank;
